module.exports = __webpack_public_path__ + "static/DSC03313-h-75ecdd8ff7b4e8319b0dc291ddbc0f04.png";